module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/132.5676e344.png";